var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('site-header'),_vm._v(" "),_c('div',{staticClass:"site-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('projects'),_vm._v(" "),_c('work-experience')],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('contact-info'),_vm._v(" "),_c('skills')],1)])]),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dd89a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteComponent.vue
// module id = null
// module chunks = 